.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  padding: 0 40px;
  border-radius: var(--radius-pill);
  background: var(--primary);
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
}

.button:hover {
  color: #ffffff;
  background: var(--primary-hover);
}
